<h2 class="my-3" [innerHTML]="'common-error-flux-title' | translate"></h2>
<p class="mb-3" [innerHTML]="'common-error-flux-description' | translate"></p>
<div routerLink="/dashboard" class="btn btn-primary w-100 mt-5">{{"error-dashboard-redirect" | translate}}</div>